import { fromJS } from 'immutable'
import {
  LEAVE_ENTITLEMENT_GET_REQUEST,
  LEAVE_ENTITLEMENT_GET_SUCCESS,
  LEAVE_ENTITLEMENT_GET_FAILURE,
  LEAVE_ENTITLEMENT_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_ENTITLEMENT_GET_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_ENTITLEMENT_GET_SUCCESS:
      return state
        .set('leaveEntitlement', fromJS(action.payload.leaveEntitlement[0]))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_GET_RESET:
      return state
        .delete('leaveEntitlement')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/leave-entitlement-get-reducer.js